import { render } from "./FirewallRulesTable.vue?vue&type=template&id=c7def548&scoped=true"
import script from "./FirewallRulesTable.vue?vue&type=script&lang=js"
export * from "./FirewallRulesTable.vue?vue&type=script&lang=js"

import "./FirewallRulesTable.vue?vue&type=style&index=0&id=c7def548&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7def548"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QTd,QTooltip,QBtn});
